import React from 'react'
import Home from './Components/home/index'
function App() {
  return (
    <div>
      <Home />
    </div>
  )
}

export default App
